// Module
var code = `{{#if .imageUrl}}
    <img class="{{.component_style}}" 
        src="{{.imageUrl}}" 
        style="{{^.imageLoaded}}visibility:hidden;{{/}}{{>visibility}}" 
        on-load="imageLoaded"
        on-error="imageNotLoaded">
{{else}}
    {{#if @global.isValidString(.name)}}
        <svg style="{{^.visible}}display:none;{{/}}">
            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{.name}}"></use>
        </svg>
    {{/if}}
{{/if}}`;
// Exports
export default code;